import React, {useEffect, useRef, useState} from 'react';
import {UsePermissions} from "../../hooks/usePermissions";
import {FormConfig} from "./components/FormConfig";
import {Navigate} from "react-router-dom";
import {UseLoader} from "../../hooks/useLoader";
import {editarConfiguracion, getConfig} from "../../api/configuracion.service";
import {Toast} from "primereact/toast";


export const ConfiguracionPage = () => {
    const [permisos] = UsePermissions();
    const [handleLoad] = UseLoader();
    const toast = useRef(null);
    const [params, setParams] = useState({});

    const getconfig = async () => {
        try {
            handleLoad(true);
            const response = await getConfig();
            handleLoad(false);
            return await response.data;
        } catch (e) {
            console.log(e)
            handleLoad(false);
        }
    }

    const getConfigPromise = () => {
        getconfig().then(r => {
            if (r.estado !== 200) {
                toast.current?.show({severity:'error', summary: 'Alerta', detail: r.mensaje, life: 3000});
                return;
            }
            setParams({...r.data})
        })
    }

    const updateConfig = async (e) => {
        try {
            handleLoad(true);
            const response = await editarConfiguracion(e);
           const data = await response.data;
            handleLoad(false);
            if (data.estado !== 200) {
                toast.current?.show({severity:'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                return;
            }
            toast.current?.show({severity:'success', summary: 'Alerta', detail: data.mensaje, life: 3000});
            getConfigPromise();
        } catch (e) {
            console.log(e)
            handleLoad(false);
        }

    }

    useEffect(() => {
        getConfigPromise()

        return () => {
            setParams({});
        }
    }, []);

    return (

        <div className="container-relative">
            <Toast ref={toast}/>
            {permisos.consultar ? <FormConfig fields={{...params}} update={updateConfig}/> : <Navigate to="/home"/>}
        </div>
    );
};



